import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import CardDetailsFormFrames from './CardDetailsFormFrames';
import CardDetailsFormFlow from './CardDetailsFormFlow';
import { CardDetailsFormProps, FlowType } from './CardDetailsForm.types';

// Re-export so existing imports (`import { FlowType } from '.../CardDetailsForm'`) keep working.
export { FlowType };

/**
 * Card-capture form switch. Renders the checkout.com Flow implementation (`CardDetailsFormFlow`) when
 * the `flowPaymentsEnabled` LaunchDarkly flag is on, otherwise the legacy Frames implementation
 * (`CardDetailsFormFrames`). The flag defaults off, so behaviour is unchanged until it is flipped —
 * giving us an instant rollback on this payments-critical path. Both variants share
 * `CardDetailsFormProps`, so none of the call sites need to change.
 *
 * LaunchDarkly flag key: `flow-payments-enabled` (mirrors cultx-web and the mobile app).
 */
export default function CardDetailsForm(props: CardDetailsFormProps) {
  const { flowPaymentsEnabled } = useFlags();
  return flowPaymentsEnabled ? <CardDetailsFormFlow {...props} /> : <CardDetailsFormFrames {...props} />;
}
